export const NAMESPACE = 'ui-shell-core';
